import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiHome, FiAlertTriangle } = FiIcons;

function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-20 bg-gray-50">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center bg-white p-10 rounded-2xl shadow-xl max-w-lg w-full"
      >
        <div className="w-20 h-20 bg-mk-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiAlertTriangle} className="w-10 h-10 text-mk-red-600" />
        </div>
        <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Seite nicht gefunden</h2>
        <p className="text-gray-600 mb-8">
          Die gesuchte Seite existiert nicht oder wurde verschoben.
        </p>
        <Link 
          to="/" 
          className="inline-flex items-center space-x-2 bg-mk-teal-500 hover:bg-mk-teal-600 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          <SafeIcon icon={FiHome} className="w-5 h-5" />
          <span>Zurück zur Startseite</span>
        </Link>
      </motion.div>
    </div>
  );
}

export default NotFound;